import React, { useState, useEffect, useContext } from 'react';

import ResponsiveDrawer from '../components/Admin/ResponsiveDrawer'
import { MedicaidProvider } from '../contexts/MedicaidContext'
import { MedicaidTestProvider } from '../contexts/MedicaidTestContext'
import { AuthContext } from '../contexts/AuthContext'
import { RequestContext } from '../contexts/RequestContext'
import { UserContext } from '../contexts/UserContext'

import './style/Admin.css'

// Component to register getRequests with AuthContext and fetch requests on mount
function RequestInitializer() {
  const { setGetRequests } = useContext(AuthContext);
  const { getRequests } = useContext(RequestContext);

  useEffect(() => {
    setGetRequests(() => getRequests);
    // Fetch requests immediately when component mounts
    getRequests();
  }, []); // Only run once on mount

  return null;
}

// Component to fetch users on mount
function UserInitializer() {
  const { getAllUsers } = useContext(UserContext);

  useEffect(() => {
    // Fetch users immediately when component mounts
    getAllUsers(1);
  }, []); // Only run once on mount

  return null;
}

function Admin() {

    return (
        <MedicaidProvider>
            <MedicaidTestProvider>
                <RequestInitializer />
                <UserInitializer />
                <ResponsiveDrawer />
            </MedicaidTestProvider>
        </MedicaidProvider>
    )
}

export default Admin
